import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShoutBriefDto } from '../../common/general-types/shout-briefs.dto';
import { BriefResponseDto, SocialChannelEnum } from '../../common/general-types/briefs.dto';
import { summariseBriefAsk } from '@/app/common/brief-ask/summarise-brief-ask';
import { BriefService } from '../../services/brief/brief.service';
import { Location } from '@angular/common';
import { briefCarriesAdLicense } from '../../common/brief-pieces/ad-license';

@Component({
  selector: 'app-brief-results',
  standalone: true,
  imports: [],
  templateUrl: './brief-results.component.html',
  styleUrl: './brief-results.component.css'
})
export class BriefResultsComponent implements OnInit {


  /** Brief Variables */
  focussedBrief = signal<BriefResponseDto | undefined>(undefined);
  focussedBriefId = signal<string | undefined>(undefined);
  focussedShoutBrief = signal<ShoutBriefDto | undefined>(undefined);
  isUgcOnly = signal<boolean>(false);
  /** Brief Variables - END */

  /** Services */
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private location = inject(Location);
  private briefService = inject(BriefService);
  /** Services - END */

  ngOnInit(): void {
    this.focussedBriefId.set(this.route.snapshot.params['briefId']);
    if (this.focussedBriefId()) {
      this.getBrief();
      // this.getTopLineStatsByBrief(briefId)
    }
  }

  getBrief() {
    if (this.focussedBriefId()) {
      this.briefService.getBriefById(this.focussedBriefId()!).subscribe((brief: BriefResponseDto) => {
        console.log('🧩🚨🧩🚨🧩🚨 BRIEF 🧩🚨🧩🚨🧩🚨 ', brief);
        this.focussedBrief.set(brief);
        // this.focussedShoutBrief.set(brief.shoutBrief ? brief.shoutBrief as any as ShoutBriefDto : undefined);

        if (this.focussedBrief() && this.focussedBrief()!.shoutBrief) {
          this.isUgcOnly.set(false);
        } else {
          this.isUgcOnly.set(true);
        }

      });
    }
  }

  getBadgeColour() {
    const ask = summariseBriefAsk(this.focussedBrief() ?? {});
    if (ask.source === 'pieces') {
      return 'bg-primary/10 dark:bg-primary/25 text-accent ring-primary/20';
    }
    if (this.focussedBrief() && this.focussedBrief()!.shoutBrief) {
      switch (this.focussedBrief()!.shoutBrief!.socialPlatform) {
        case SocialChannelEnum['TikTok Post']:
          return 'bg-orange-50 dark:bg-orange-900/30 text-orange-700 ring-orange-600 ring-opacity-20';
        case SocialChannelEnum['Instagram Reel']:
          return 'bg-sky-50 dark:bg-sky-900/30 text-sky-700 ring-sky-600 ring-opacity-20';
        case SocialChannelEnum['Instagram Story']:
          return 'bg-primary/10 dark:bg-primary/25 text-accent ring-primary/20';
        case SocialChannelEnum['YouTube Shorts']:
          return 'bg-red-50 dark:bg-red-900/30 text-red-700 ring-red-600 ring-opacity-20';
        case SocialChannelEnum['Snapchat Spotlight']:
          return 'bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 ring-yellow-600 ring-opacity-20';
        case SocialChannelEnum['Snapchat Story']:
          return 'bg-gold-50 dark:bg-gold-900/30 text-gold-700 ring-gold-600 ring-opacity-20';
        default:
          return 'bg-primary/10 dark:bg-primary/25 text-accent ring-primary/20';
      }
    } else if (briefCarriesAdLicense(this.focussedBrief())) {
      return 'bg-teal-50 dark:bg-teal-900/30 text-teal-700 ring-teal-600 ring-opacity-20';
    } else {
      return 'bg-primary/10 dark:bg-primary/25 text-accent ring-primary/20';
    }
  }

  getPostType() {
    const ask = summariseBriefAsk(this.focussedBrief() ?? {});
    if (ask.source === 'pieces') {
      return ask.label;
    }
    if (this.focussedBrief() && this.focussedBrief()?.shoutBrief) {
      switch (this.focussedBrief()?.shoutBrief?.socialPlatform) {
        case SocialChannelEnum['TikTok Post']:
          return 'TikTok Post';
        case SocialChannelEnum['Instagram Reel']:
          return 'Instagram Reel';
        case SocialChannelEnum['Instagram Story']:
          return 'Instagram Story';
        case SocialChannelEnum['YouTube Shorts']:
          return 'YouTube Shorts';
        case SocialChannelEnum['Snapchat Spotlight']:
          return 'Snapchat Spotlight';
        case SocialChannelEnum['Snapchat Story']:
          return 'Snapchat Story';
        default:
          return 'Social Post';
      }
    } else if (briefCarriesAdLicense(this.focussedBrief())) {
      return 'Ad Content';
    } else {
      return 'UGC Only';
    }
  }

  backToBriefs() {
    this.location.back();
  }
}
